import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import swal from "sweetalert2";
import { error } from "console";
import { FormsModule } from "@angular/forms";
import { RestService } from "../../master-services/Rest/rest.service";
import { UserService } from "../../master-services/User/user.service";
import { UploadService } from "../../master-services/services/upload.service";

@Component({
  selector: "area-check-list",
  templateUrl: "./area-check-list.component.html",
  styleUrls: ["./area-check-list.component.scss"],
})
export class AreaCheckListComponent implements OnInit {
  areaList: any;
  checkListAll: any;
  checkListFilter: any;
  customers: any;
  userSelects: any;
  userProfile: number = 0;

  public filterCriteria = {
    userId: "",
    company: "",
    startDate: "",
    endDate: "",
    status: "",
    passing_date: "",
  };

  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private UserService: UserService,
    private AreasService: AreasService,
    private restService: RestService,
    private UploadService:UploadService
  ) {
    //this.index();
  }
  ngOnInit() {
    this.userProfile = Number(localStorage.getItem('profile'));
    this.getArea();
    console.warn("Acaaa iniciando el componente de reportes");
    this.getchecklist_All();
    this.getCustomers();
    this.getUser();
    this.logUploadkeys();
  }

  index() {}

   logUploadkeys(){
     console.warn("Acaaa Consultando upload services");
     this.UploadService.logData()
   }



  getArea() {
    this.AreasService.getArea()
      .then((data) => {
        const reps: any = data;
        this.areaList = reps.data;
      })
      .catch((error) => console.log(error));
  }

  managearea(id: any) {
    this.router.navigateByUrl("erp/CheckListComponent/" + id);
  }

  getchecklist_All() {
    console.log("Acaaaaa obtendre el get de listas");

    this.AreasService.checkListAll()
      .then((data) => {
        const rest: any = data;
        console.log("Acaaa checkListAll", rest.data);
        if (this.userProfile === 3) {
          this.checkListAll = rest.data.filter(check => check.area_id === 16);
        } else {
          this.checkListAll = rest.data;
        }
        console.log("Acaaa checkListAll", this.checkListAll);
      })
      .catch((error) => alert(error));
  }

  AdminInspection(item) {
    console.log("Acaa item para administrar de inspeccion", item);
    const id = item.checkListUserId;
    console.log("Acaaa pasare la checklistUserId", id);
    this.router.navigateByUrl("erp/CheckListComponent/" + id);
  }

  getCustomers() {
    this.restService
      .getCustomer()
      .then((data) => {
        const resp: any = data;
        //console.log(data);
        swal.close();
        this.customers = resp.data;
        //console.log("data Cust", this.customers);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  applyFilters() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    console.log("Acaaa aplicar los filtros", this.filterCriteria);
    const queryParams = new URLSearchParams();

    if (
      !this.filterCriteria.userId &&
      !this.filterCriteria.company &&
      !this.filterCriteria.startDate &&
      !this.filterCriteria.endDate &&
      !this.filterCriteria.status &&
      !this.filterCriteria.passing_date
    ) {
      console.log("Debe seleccionar al menos un criterio de filtrado.");
      alert("Debe seleccionar al menos un criterio de filtrado.");
      return;
    }

    ///Aca los if

    if (this.filterCriteria.userId) {
      queryParams.append("userId", this.filterCriteria.userId);
      console.log("Filtro añadido - userId:", this.filterCriteria.userId);
    }

    if (this.filterCriteria.company) {
      queryParams.append("company", this.filterCriteria.company);
      console.log("Filtro añadido - company:", this.filterCriteria.company);
    }

    if (this.filterCriteria.startDate) {
      queryParams.append("startDate", this.filterCriteria.startDate);
      console.log("Filtro añadido - startDate:", this.filterCriteria.startDate);
    }

    if (this.filterCriteria.endDate) {
      queryParams.append("endDate", this.filterCriteria.endDate);
      console.log("Filtro añadido - endDate:", this.filterCriteria.endDate);
    }

    if (this.filterCriteria.status) {
      queryParams.append("status", this.filterCriteria.status);
      console.log("Filtro añadido - status:", this.filterCriteria.status);
    }

    if (this.filterCriteria.passing_date) {
      queryParams.append("passing_date", this.filterCriteria.passing_date);
      console.log(
        "Filtro añadido - passing_date:",
        this.filterCriteria.passing_date
      );
    }

    const queryString = queryParams.toString();

    console.log("Cadena de consulta (queryString):", queryString);
    console.log("Llamada al servicio con queryString:", queryString);
    this.AreasService.checkListFilter(queryString)
      .then((data) => {
        const rest: any = data;
        this.checkListFilter = rest.data;
        console.log("Acaaa checkListFilter", this.checkListFilter);
        swal.close();
      })
      .catch((error) => alert(error));
  }

  getUser() {
    swal({
      title: "Obteniendo información...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.UserService.getUsers()
      .then((data) => {
        const resp: any = data;
        this.userSelects = resp.data;
        //console.log("Aca Data de user", data);
        //console.log("Aca Data de userSelects", this.userSelects);
        swal.close();
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  getStatusText(status: number) {
    switch (status) {
      case 2:
        return "Asignado";
      case 3:
        return "Contestado";
      case 5:
        return "Finalizado";
      default:
        return "Sin estado";
    }
  }

  /////
}



// WEBPACK FOOTER //
// ./src/app/master/area-check-listpdf/area-check-list.component.ts